<template>
  <div class="404-page">
    <header-back
      :title="baseinfo.comname"
      @back="onClickBack"
    />
    <img
      src="@/assets/images/blank.png"
      class="logo-img"
    >
    <div class="content placeholder">
      <p>当前项目已被关闭，</p>
      <p>可联系组织创始人/管理员开启</p>
    </div>
    <cube-button
      type="submit"
      :primary="true"
      class="btn"
      @click="onClickBack"
    >
      返回
    </cube-button>
  </div>
</template>

<script>
import HeaderBack from '@/components/mobile/HeaderBack'
import { mapState } from 'vuex'

export default {
  components: {
    HeaderBack
  },
  data () {
    return {}
  },
  computed: {
    ...mapState(['baseinfo'])
  },
  methods: {
    onClickBack () {
      this.$router.push({
        name: 'ProjectIndexPc',
        query: {
          cid: this.$route.query.cid * 1 || this.$store.state.baseinfo.cid,
          type: 'inquery'
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.logo-img {
  display: block;
  width: 137px;
  margin: 26px auto 14px;
}
.placeholder {
  margin-bottom: 24px;
  font-size: 16px;
  color: #999;
  line-height: 24px;
  text-align: center;
}
.btn {
  width: 200px;
  margin: 0 auto;
}
</style>
